module.exports = __webpack_public_path__ + "h5/img/floor1.42678336.jpg";